import { Component, Inject, Input, OnInit } from '@angular/core';
import { CompaniesService } from '../../../../services/companies.service';
import { RouteParamsService } from '../../../../services/route-params.service';
import { first } from 'rxjs/operators';
import { ClientSetup } from '../../../../models/client';
import { Router } from '@angular/router';
import { InstanceTypes } from '../../../../models/instance-types';

@Component({
  selector: 'lib-print-checks',
  templateUrl: './print-checks.component.html',
  styleUrls: ['./print-checks.component.css'],
  standalone: false
})
export class PrintChecksComponent implements OnInit {
  @Input()
  public clientCode: string;
  public get canDisplayTile() {
    return (
      this.setup != null &&
      (this.setup.AllowsCheckPrinting || this.setup.HasCentralChecking) &&
      this.env.instanceType == InstanceTypes.ClientPortal
    );
  }

  private setup: ClientSetup;
  constructor(
    private companyService: CompaniesService,
    private router: Router,
    @Inject('env') private env: any
  ) {}

  ngOnInit() {
    this.companyService.getClientSetup(this.clientCode).subscribe(result => {
      this.setup = result;
    });
  }

  clicked() {
    this.router.navigate([`/client/${this.clientCode}/print-checks`]);
  }
}
